/**
 * useProducts
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import ProductsContext from './products-context'

const useProducts = () => {
  const context = useContext(ProductsContext)
  return context
}

export default useProducts
